// extracted by mini-css-extract-plugin
export default {"added":"CollectUsers_added__PyBm5","add":"CollectUsers_add__YW-mV","searchBox":"CollectUsers_searchBox__E0r3O"};